import dayjs from 'dayjs';
import 'dayjs/locale/fr';

export default {

  data () {
    return {
      responseErr: null,
      isProcessing: false,
      clearing: null,
      properties: ['transaction.idOperation',
        'transaction.classeTransaction',
        'transaction.technicalStatus',
        'transaction.technicalErrorType',
        'transaction.technicalErrorDetail',
        'transaction.clearingStatus',
        'transaction.transmissionDateAndTime',
        'transaction.processingDate',
        'transaction.transactionStatus',
        'transaction.rejectReasonCode',
        'transaction.partialFlag',
        'transaction.claimCbkId',
        'transaction.cbkId',
        'transaction.cardIssuerReferenceData',
        'transaction.reasonCode',
        'transaction.messageText',
        'transaction.reversalFlag',
        'transaction.direction',
        'transaction.collectionDisbursementFlag',
        'transaction.typeFacture',
        'transaction.issuerId',
        'transaction.distributorRef',
        'transaction.memberId',
        'transaction.memberIdRec',
        'transaction.cardSchemeCode',
        'transaction.technicalProduct',
        'transaction.brand',
        'transaction.pan',
        'transaction.cardId',
        'transaction.expiryDate',
        'transaction.psn',
        'transaction.productExternalReference',
        'transaction.cardStatus',
        'transaction.beneficiaryServiceExternalReference',
        'transaction.libServiceBenef',
        'funder.label',
        'funder.funderContractRef',
        'funder.libContratFinanceur',
        'funder.statutContratFinanceur',
        'funder.funderProfilRef',
        'transaction.acquiringBIN',
        'transaction.idContratAffilie',
        'transaction.idMarchand',
        'transaction.idStructure',
        'transaction.accountCategory',
        'transaction.accountNumber',
        'transaction.nomMarchand',
        'transaction.rueMarchand',
        'transaction.villeMarchand',
        'transaction.codepostalMarchand',
        'transaction.regionMarchand',
        'transaction.countryCode',
        'transaction.idTerminal',
        'transaction.idAcceptation',
        'transaction.codeMCC',
        'transaction.acquirerReferenceNumber',
        'transaction.retrievalReferenceNumber',
        'transaction.traceNumber',
        'transaction.idRemise',
        'transaction.paymentFacilitatorId',
        'transaction.subMerchantId',
        'transaction.transactionType',
        'transaction.canalAcceptationValue',
        'transaction.posEntryMode',
        'transaction.transactionOriginatorInstitutionIdCode',
        'transaction.transactionDestinationInstitutionIdCode',
        'transaction.dateTransaction',
        'transaction.transactionAmount',
        'transaction.reconciliationAmount',
        'transaction.exchangeRate',
        'transaction.cardHolderBillingAmount',
        'transaction.cardholderConversionRate',
        'transaction.amountBeforeTopUp',
        'transaction.complementAmount',
        'transaction.interchangeFees',
        'transaction.settlementDate',
        'transaction.numAut',
        'transaction.traceId',
        'transaction.originalIdOperation',
        'transaction.directSettlementMode',
        'transaction.directSettlementInformation',
        'transaction.externalReference',
        'transaction.accountImpact',
        'transaction.ecomm.transacIdAcceptor',
        'transaction.ecomm.cardholderAuthMethod',
        'transaction.ecomm.indicator',
        'transaction.ecomm.cryptogram',
        'transaction.ecomm.cryptogramCalcMethod',
        'transaction.ecomm.cryptogramProcessInfo',
        'transaction.ecomm.resultUseSecArch',
        'transaction.ecomm.securityType',
        'transaction.ecomm.modifiedSecurityMode',
        'transaction.ecomm.additionalData',
        'transaction.ecomm.securityProtocol',
        'transaction.ecomm.cardholderAuthentification',
        'transaction.ecomm.ucafCollectionIndicator',
        'transaction.ecomm.directoryServerTransactionId',
        'transaction.ecomm.programProtocol',
        'transaction.xpay.tokenRequestorId',
        'transaction.xpay.deviceType',
        'transaction.xpay.tokenWalletId',
        'transaction.dateFichier',
        'transaction.dateExtraction',
        'transaction.statutExtraction',
        'transaction.fileId',
        'transaction.numMessage',
        'authorization.detail.scpRequestDate',
        'authorization.detail.scpResponseDate',
        'authorization.detail.scpResponseCode']
    }
  },

  created () {
    if (!this.$store.state.clearings.clearingDetail) {
      this.$store.dispatch('clearings/invalidData', 'CLEARING_EMPTY')
      this.$router.push({ name: 'clearing-list' })
    }
    else {
      this.$store.dispatch('clearings/resetInvalidData')
      this.getDetail(this.$store.state.clearings.clearingDetail)
    }
  },

  methods: {
    async getDetail (clearing) {
      this.isProcessing = true
      this.responseErr = null
      await this.$store.dispatch('clearings/get',
        clearing.idOperation
      ).then(
        () => {
          this.isProcessing = false
          this.clearing = this.$store.state.clearings.clearing
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    showClearing (originalIdOperation) {
      let clearing = {}
      clearing.idOperation = originalIdOperation
      this.$store.dispatch('clearings/setClearingDetail', clearing)
      this.getDetail(clearing)
    },

    downloadCSV () {
      const csv = this.loadCSV()
      const hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = dayjs().format('YYYYMMDD_HHmmss').concat('.csv')
      hiddenElement.click()
    },

    loadCSV () {
      let csv = ''

      this.properties.forEach(key => {
        if (csv) {
          csv += ';'.concat(this.getCSVHeaderLabel(key))
        } else {
          csv += this.getCSVHeaderLabel(key)
        }
      })
      csv += '\n'

      let csvLine = ''
      this.properties.forEach(key => {
        if (csvLine) {
          csvLine += ';'.concat(this.getCSVValue(key, this.clearing))
        } else {
          csvLine += this.getCSVValue(key, this.clearing)
        }
      })
      csv += csvLine.concat('\n')

      return csv
    },

    getCSVHeaderLabel (key) {
      return key.includes('authorization.') ? this.$i18n.t('label.'.concat(key)) : this.$i18n.t('label.clearing.detail.'.concat(key))
    },

    formatCSVValue (key, value) {
      switch (key) {
        case 'dateTransaction':
        case 'processingDate':
        case 'settlementDate':
        case 'transmissionDateAndTime':
        case 'externalOutputTimestamp':
        case 'dateFichier':
        case 'dateExtraction':
        case 'actionDateAndTime':
        case 'scpRequestDate':
        case 'scpResponseDate':
          return value ? this.$filters.date(value) : value
        case 'reversalFlag':
        case 'offlineFlag':
        case 'accountImpact':
          return value ? this.$filters.boolean(value) : value
        case 'transactionAmount':
        case 'reconciliationAmount':
        case 'cardHolderBillingAmount':
        case 'cardholderAmount':
        case 'offlineAutReversalAmount':
        case 'interchangeFees':
        case 'amountBeforeTopUp':
        case 'complementAmount':
          return value ? this.$filters.currency(value.amount, value.currency) : value
        case 'exchangeRate':
        case 'cardholderConversionRate':
          return value ? this.$filters.conversionRate(value.rate, value.exponent) : value
        default:
          return value
      }
    },

    getCSVValue (key, clearing) {
      let value = null
      switch (key) {
        case 'transaction.idOperation':
        case 'transaction.classeTransaction':
        case 'transaction.technicalStatus':
        case 'transaction.technicalErrorType':
        case 'transaction.technicalErrorDetail':
        case 'transaction.clearingStatus':
        case 'transaction.transmissionDateAndTime':
        case 'transaction.processingDate':
        case 'transaction.transactionStatus':
        case 'transaction.rejectReasonCode':
        case 'transaction.partialFlag':
        case 'transaction.claimCbkId':
        case 'transaction.cbkId':
        case 'transaction.cardIssuerReferenceData':
        case 'transaction.reasonCode':
        case 'transaction.messageText':
        case 'transaction.reversalFlag':
        case 'transaction.direction':
        case 'transaction.collectionDisbursementFlag':
        case 'transaction.typeFacture':
        case 'transaction.issuerId':
        case 'transaction.distributorRef':
        case 'transaction.memberId':
        case 'transaction.memberIdRec':
        case 'transaction.cardSchemeCode':
        case 'transaction.technicalProduct':
        case 'transaction.brand':
        case 'transaction.pan':
        case 'transaction.cardId':
        case 'transaction.expiryDate':
        case 'transaction.psn':
        case 'transaction.cardStatus':
        case 'transaction.libServiceBenef':
        case 'transaction.acquiringBIN':
        case 'transaction.idContratAffilie':
        case 'transaction.idMarchand':
        case 'transaction.idStructure':
        case 'transaction.accountCategory':
        case 'transaction.accountNumber':
        case 'transaction.nomMarchand':
        case 'transaction.rueMarchand':
        case 'transaction.villeMarchand':
        case 'transaction.codepostalMarchand':
        case 'transaction.regionMarchand':
        case 'transaction.countryCode':
        case 'transaction.idTerminal':
        case 'transaction.idAcceptation':
        case 'transaction.codeMCC':
        case 'transaction.acquirerReferenceNumber':
        case 'transaction.retrievalReferenceNumber':
        case 'transaction.traceNumber':
        case 'transaction.idRemise':
        case 'transaction.paymentFacilitatorId':
        case 'transaction.subMerchantId':
        case 'transaction.transactionType':
        case 'transaction.canalAcceptationValue':
        case 'transaction.posEntryMode':
        case 'transaction.transactionOriginatorInstitutionIdCode':
        case 'transaction.transactionDestinationInstitutionIdCode':
        case 'transaction.dateTransaction':
        case 'transaction.transactionAmount':
        case 'transaction.reconciliationAmount':
        case 'transaction.exchangeRate':
        case 'transaction.cardHolderBillingAmount':
        case 'transaction.cardholderConversionRate':
        case 'transaction.amountBeforeTopUp':
        case 'transaction.complementAmount':
        case 'transaction.interchangeFees':
        case 'transaction.settlementDate':
        case 'transaction.numAut':
        case 'transaction.traceId':
        case 'transaction.originalIdOperation':
        case 'transaction.directSettlementMode':
        case 'transaction.directSettlementInformation':
        case 'transaction.externalReference':
        case 'transaction.accountImpact':
        case 'transaction.dateFichier':
        case 'transaction.dateExtraction':
        case 'transaction.statutExtraction':
        case 'transaction.fileId':
        case 'transaction.numMessage':
          value = clearing.transaction ? this.formatCSVValue(key.replace('transaction.', ''), clearing.transaction[key.replace('transaction.', '')]) : ''
          break
        case 'transaction.xpay.tokenRequestorId':
        case 'transaction.xpay.deviceType':
        case 'transaction.xpay.tokenWalletId':
          value = clearing.transaction && clearing.transaction.xpay ? clearing.transaction.xpay[key.replace('transaction.xpay.', '')] : ''
          break
        case 'transaction.beneficiaryServiceExternalReference':
        case 'transaction.productExternalReference':
          value = clearing.beneficiary ? clearing.beneficiary[key.replace('transaction.', '')] : ''
          break
        case 'funder.label':
        case 'funder.funderContractRef':
        case 'funder.libContratFinanceur':
        case 'funder.statutContratFinanceur':
        case 'funder.funderProfilRef':
          value = clearing.funder ? clearing.funder[key.replace('funder.', '')] : ''
          break
        case 'authorization.detail.scpRequestDate':
        case 'authorization.detail.scpResponseDate':
        case 'authorization.detail.scpResponseCode':
          value = clearing.transaction && clearing.transaction.clearingPaymentComplement ? this.formatCSVValue(key.replace('authorization.detail.', ''), clearing.transaction.clearingPaymentComplement[key.replace('authorization.detail.', '')]) : ''
          break
        case 'transaction.ecomm.transacIdAcceptor':
        case 'transaction.ecomm.cardholderAuthMethod':
        case 'transaction.ecomm.indicator':
        case 'transaction.ecomm.cryptogram':
        case 'transaction.ecomm.cryptogramCalcMethod':
        case 'transaction.ecomm.cryptogramProcessInfo':
        case 'transaction.ecomm.resultUseSecArch':
        case 'transaction.ecomm.securityType':
        case 'transaction.ecomm.modifiedSecurityMode':
        case 'transaction.ecomm.additionalData':
        case 'transaction.ecomm.securityProtocol':
        case 'transaction.ecomm.cardholderAuthentification':
        case 'transaction.ecomm.ucafCollectionIndicator':
        case 'transaction.ecomm.directoryServerTransactionId':
        case 'transaction.ecomm.programProtocol':
          value = ''
          if (clearing.transaction.ecomm) {
            clearing.transaction.ecomm.forEach(ecomm => {
              if (value) {
                value += '\n'.concat(ecomm[key.replace('transaction.ecomm.', '')])
              } else {
                value += '"'.concat(ecomm[key.replace('transaction.ecomm.', '')])
              }
            })
            value += '"'
          }
          break
      }

      switch (value) {
        case null:
        case undefined:
          return ''
        default:
          return value
      }
    }
  }
}
